import { useQuery } from '@tanstack/react-query';

import { fetchCarrierShipmentConfig } from '../data-provider/carrier-shipment-configuration';
import type { CarrierShipmentConfigRequestParams } from '../data-provider/carrier-shipment-configuration/api';

type Params = CarrierShipmentConfigRequestParams & { enabled?: boolean; companyId?: number };

export const useGetCarrierShipmentConfig = ({ enabled = true, companyId, ...params }: Partial<Params>) => {
  return useQuery({
    enabled: enabled && Boolean(params.customerKey) && Boolean(companyId),
    queryFn: () => fetchCarrierShipmentConfig({ customerKey: params?.customerKey as number }),
    queryKey: ['carrier-shipment-config-visibility', params.customerKey, companyId],
    // biome-ignore lint/style/noMagicNumbers: 15 min
    staleTime: 1000 * 60 * 15,
  });
};
